export function parsePrice(value: string): { currency: string; value: number} | null {
    try {
        const [currency, valueString] = value.trim().split(' ');
        const valueParsed = parseFloat(valueString);
        return {
            currency,
            value: valueParsed > 0 ? valueParsed : 0,
        };
    } catch {
        return null;
    }
}
